import { createBrowserRouter } from "react-router-dom";
import Main from "../layout/main/Main";
import Home from "../pages/home/Home";
import ProjectDetails from "../pages/projectDetails/ProjectDetails";
import { findById } from "../utils/fineById";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Main />,
    // errorElement: <Error />,
    children: [
      { path: "/", element: <Home /> },
      {
        path: "/project/:id",
        loader: async ({ params }) => {
          return findById({ object: "projectsData", id: params?.id }) || null; // Ensure a return value
        },
        element: <ProjectDetails />,
      },
    ],
  },
]);
